import { useEffect, useRef, useState } from "react";
import { cn } from "@/lib/cn";

/**
 * Animates a numeric value when scrolled into view. Subtle, no bouncing.
 */
export const AnimatedNumber = ({
  value,
  format = (v) => v.toLocaleString(),
  duration = 1200,
  className,
  testId,
}) => {
  const ref = useRef(null);
  const [display, setDisplay] = useState(0);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started) {
          setStarted(true);
          const start = performance.now();
          const tick = (now) => {
            const elapsed = now - start;
            const t = Math.min(1, elapsed / duration);
            // ease-out-expo
            const eased = t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
            setDisplay(value * eased);
            if (t < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        }
      },
      { threshold: 0.3 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [value, duration, started]);

  return (
    <span
      ref={ref}
      data-testid={testId || "animated-number"}
      className={cn("tabular-nums", className)}
    >
      {format(display)}
    </span>
  );
};

export default AnimatedNumber;
